<template>
  <div></div>
</template>

<script>
/*
 *   BEGIN INTERCOM
 */
const jwt = require('jsonwebtoken')
export default {
  async beforeMount() {
    if (this.$cookies.get('auth._token.uptogether')) {
      const decodedAccessToken = jwt.decode(
        this.$cookies.get('auth._token.uptogether')
      )
      const userHash = await this.getUserHash()
      const fullName =
        decodedAccessToken.identity.meta.first_name ||
        decodedAccessToken.identity.meta.last_name
          ? decodedAccessToken.identity.meta.first_name +
            ' ' +
            decodedAccessToken.identity.meta.last_name
          : decodedAccessToken.identity.meta.email
      window.intercomSettings = {
        app_id: `${process.env.INTERCOM_APP_ID}`, // The INTERCOM_APP_ID is set in the .env file of the web.* projects
        name: fullName,
        user_id: decodedAccessToken.identity.entity_uuid,
        user_hash: userHash,
        email: decodedAccessToken.identity.meta.email,
        'Date Of Birth': decodedAccessToken.identity.meta.dob
          ? decodedAccessToken.identity.meta.dob
          : '',
        language: decodedAccessToken.identity.meta.language_preference
          ? decodedAccessToken.identity.meta.language_preference.language
            ? decodedAccessToken.identity.meta.language_preference.language
            : ''
          : '',
        phone: decodedAccessToken.identity.meta.phone
          ? decodedAccessToken.identity.meta.phone
          : '',
        'Entity URL': `https://ops.uptogether.org/entity/${decodedAccessToken.identity.entity_uuid}`,
        'Entity Support URL': `https://supporthq.uptogether.org/search/${decodedAccessToken.identity.entity_uuid}`,
        'Amplitude URL': `https://analytics.amplitude.com/uptogether/project/${process.env.AMPLITUDE_PROJECT_ID}/search/${decodedAccessToken.identity.entity_uuid}`,
        tags: decodedAccessToken.identity.tags,
      }
    } else {
      window.intercomSettings = {
        app_id: `${process.env.INTERCOM_APP_ID}`,
      }
    }

    // We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/drnlj5h7'
    ;(function () {
      const w = window
      const ic = w.Intercom
      if (typeof ic === 'function') {
        ic('reattach_activator')
        ic('update', w.intercomSettings)
      } else {
        const d = document
        const i = function () {
          i.c(arguments)
        }
        i.q = []
        i.c = function (args) {
          i.q.push(args)
        }
        w.Intercom = i
        const l = function () {
          const s = d.createElement('script')
          s.type = 'text/javascript'
          s.async = true
          s.src = `https://widget.intercom.io/widget/${process.env.INTERCOM_APP_ID}}`
          const x = d.getElementsByTagName('script')[0]
          x.parentNode.insertBefore(s, x)
        }
        if (document.readyState === 'complete') {
          l()
        } else if (w.attachEvent) {
          w.attachEvent('onload', l)
        } else {
          w.addEventListener('load', l, false)
        }
      }
    })()

    try {
      window.Intercom('boot', {
        app_id: `${process.env.INTERCOM_APP_ID}`,
      })

      window.Intercom('update')
    } catch (e) {
      console.log('Error with externalScripts: ', e)
    } finally {
      console.log('Finished ExternalScripts')
    }
  },
  methods: {
    async getUserHash() {
      const response = await this.$axios.$get(`/CORE_URL/profile/intercom`)
      return response.hash
    },
  },
}

/*
 *   END INTERCOM
 */
</script>
